module.exports = __webpack_public_path__ + "static/img/global_explain@3x.7b5c007.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/global_explain@3x.png
// module id = Mr6t
// module chunks = 1